import React, {useEffect, useState} from 'react';
import {getChildStatusData} from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownChildStatus = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getChildStatusData(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownChildStatus;

DropdownChildStatus.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownChildStatus.propTypes = {
    onChange: PropTypes.func.isRequired
};